import router from '../../router'
import * as types from '../types'
let http = require('../../assets/js/http');
let cookie = require('../../assets/js/cookie');


const state = {
  isLogin: cookie.getCookie("userToken"),
  accountName:undefined,
  switch:true,//控制跳转链接是正式还是测试
};

const getters = {
  isLogin:()=>{
    return state.isLogin != "" ? true : false
  },
  accountName:()=>{
    return state.accountName;
  }
};

const actions = {
  // 登陆
  login: ({commit, dispatch}, playload) => {
    http.doLogin(playload.page, {
      "accountName": playload.accountName,
      "password": playload.password
    }, function (response) {
      localStorage.setItem("organId",response.data.result.organId);
      localStorage.setItem("roleName",response.data.result.rolesVOList[0].roleName);
      commit(types.LOGINSUCCESS,{accountName:playload.accountName});
    }, function (response) {
      playload.page.$message.error(response.data.result);
    });
  },

  // 退出
  logout: ({commit},playload) => {
    http.doLogout(playload.page, {}, function (response) {
      commit(types.LOGOUTSUCCESS);
    });
  }
};

const mutations = {
  [types.LOGINSUCCESS](state,{accountName}){
    state.isLogin = true;
    document.body.style.background="#eee";
    router.push({path: "/"});
    state.accountName = accountName
    // state.accountName = playload.accountName
  },
  [types.LOGOUTSUCCESS](state){
    state.isLogin = false;
    cookie.clearCookie("userToken");
    router.push({path: "/login"});
  },
  [types.HIDEMENU](state,playload){
    state.isLogin = playload.state;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js